import { createAction } from "@reduxjs/toolkit";
import axios from 'apis';
import { asyncThunkWrapper } from "helpers/asyncThunkWrapper";

const attributes = ['id', 'email', 'context', 'updated_at'];

export const getFillFlow = asyncThunkWrapper({ 
  model: 'fillFlow', 
  action: 'getFillFlow', 
  func: async () => {
    const params = { attributes };
    const response = await axios.get(`/fill_flow`, { params });

    return response.data;
  } 
});
export const createFillFlow = asyncThunkWrapper({ 
  model: 'fillFlow', 
  action: 'createFillFlow', 
  func: async (fill_flow) => {
    const response = await axios.post(`/fill_flow`, { fill_flow, attributes });

    return response.data;
  } 
});
export const updateFillFlow = asyncThunkWrapper({ 
  model: 'fillFlow', 
  action: 'updateFillFlow', 
  func: async (fill_flow) => {
    const response = await axios.patch(`/fill_flow`, { fill_flow });

    return { status: response.status, fill_flow };
  } 
});
export const deleteFillFlow = asyncThunkWrapper({ 
  model: 'fillFlow', 
  action: 'deleteFillFlow', 
  func: async () => {
    const response = await axios.delete(`/fill_flow`);

    return { status: response.status };
  } 
});
export const clearLocalActiveFillFlow = createAction('fillFlow/clearLocalActiveFillFlow');